module.exports = __webpack_public_path__ + "static/media/medical history.71951c20.svg";